import React from 'react';
import styled from '@emotion/styled';

const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 5rem;
    height: 2.25rem;
    
    color: var(--company-dark);
    background: var(--color-gray-100);

    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: 0.25rem;
    
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-16);
    line-height: var(--font-16);
    
    cursor: pointer;

    span{
        padding-left: 0.5rem;
    }
    
    &:hover {
        background: var(--color-gray-200);
    }

    @media (max-width: 500px){
        width: 100%;
    }
`;

function BackButtonComponent({onClick}) {
    return <ButtonContainer onClick={onClick}>
        <img src="/icons/back_button.svg"/> <span>Back</span>
    </ButtonContainer>
}

export default BackButtonComponent;
